/*
 *
 * RestorePasswordForm constants
 *
 */

export const SUBMIT = 'claris-vnext/RestorePasswordForm/SUBMIT';
